// extracted by mini-css-extract-plugin
module.exports = {"emptyRequest":"EmptyRequest_emptyRequest__2BQz9","emptyRequestIcon":"EmptyRequest_emptyRequestIcon__9dvh2","buttonIcon":"EmptyRequest_buttonIcon__3AJZx"};